module.exports = __webpack_public_path__ + "static/media/payment.5e1d42f6.png";